<button class="btn icon" type="button" routerLink="/account">
  <span>
    <i class="fas fa-user"></i>
  </span>
  <span>
    {{ "home.controls.account" | translate }}
  </span>
</button>

<button class="btn icon" type="button" routerLink="/reports">
  <span>
    <i class="fa fa-chart-bar" aria-hidden="true"></i>
  </span>
  <span>
    {{ "home.controls.reports" | translate }}
  </span>
</button>

<button class="btn icon" type="button" (click)="onLogout()">
  <span>
    <i class="fas fa-sign-out-alt"></i>
  </span>
  <span>
    {{ "home.controls.logout" | translate }}
  </span>
</button>
